import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouses/:warehouseId/transfer-units`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const transferUnits = {
  post: apiPathFunc(pathBase),
};
